"use strict";
const progressScreen = document.getElementById('start___progress_screen');
const imgList = document.querySelectorAll('img[src]');
const progressBar = document.getElementById('progress___bar');
const animIcon = document.getElementById('progress___logo');
const mq = window.matchMedia('(min-width: 681px)');
const bodyTop = document.querySelector('body.top');
let completeCounter = 0;
let progress = 0;
const loop = () => {
    if (!progressScreen)
        return; // progress screenが無い場合は何もしない
    progress = completeCounter / imgList.length;
    if (progress < 1) {
        progressBar.style.width = 100 * progress + '%';
        requestAnimationFrame(loop);
    }
    else if (progress === 1) {
        const gHeader = document.getElementById('global_header');
        const gHeaderHeight = gHeader.getBoundingClientRect().height;
        progressBar.style.width = '100%';
        setTimeout(() => {
            // console.log('1');
            animIcon.classList.add('is___loaded');
        }, 400);
        setTimeout(() => {
            // console.log('2');
            animIcon.classList.add('is___start');
            progressBar.style.top = `${mq.matches ? gHeaderHeight - 8 : gHeaderHeight + 6}px`;
            progressBar.classList.add('is___start');
        }, 1000);
        setTimeout(() => {
            // console.log('3');
            progressScreen.classList.add('is___complete');
            sessionStorage.setItem('takumi_ss_log', 'true');
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        }, 1400);
        setTimeout(() => {
            // console.log('completed');
            bodyTop.classList.add('loaded');
        }, 2200);
    }
};
document.addEventListener('DOMContentLoaded', () => {
    // topページ以外
    if (!bodyTop)
        return;
    if (!progressScreen)
        return; // progress screenが無い場合は何もしない
    if (sessionStorage.getItem('takumi_ss_log') !== 'true') {
        animIcon.style.display = 'block';
        // document.documentElement.style.overflow = 'hidden';
        // document.body.style.overflow = 'hidden';
        if (imgList !== null) {
            imgList.forEach((elem, index) => {
                var _a;
                const image = new Image();
                image.src = (_a = elem.getAttribute('src')) !== null && _a !== void 0 ? _a : '';
                image.onload = () => {
                    setTimeout(() => {
                        completeCounter++;
                    }, 200 * (index + 1));
                };
            });
            loop();
        }
    }
    else {
        if (!progressScreen)
            return;
        progressScreen.style.display = 'none';
        bodyTop.classList.add('loaded');
    }
});
